import { AxiosResponse } from "axios";
import { parseApiResponse } from "./parseApiResponse";

export const parseApiData = async <T = any>(request: Promise<AxiosResponse<T, any>>): Promise<any> => {
	const parsedApiResponse = await parseApiResponse(request);
	if (parsedApiResponse?.data !== undefined) return parsedApiResponse.data;
	return parsedApiResponse;
};
